import { stripUndefined } from '@halo/helpers/clean-objects'
import { PlatformFlagEntities } from '@halo/enums/platform-flag-entities'

export class FlagModel {
    public static build(data: any): FlagModel {
        data = data instanceof FlagModel ? data.serialize() : data

        const model = new FlagModel()
        model.setKey(data.key)
        model.setDisplayName(data.display_name)
        model.setDescription(data.description)
        model.setApplicableEntities(data.applicable_entities ?? [])
        model.setDefaultForEntities(data.default_for_entities ?? [])
        model.setIsActive(data.is_active)
        model.setIsDevOnly(data.is_dev_only)
        model.setIsSdkFlag(data.is_sdk_flag)

        return model
    }

    private key: string
    private display_name: string
    private description: string
    private applicable_entities: PlatformFlagEntities[]
    private default_for_entities: PlatformFlagEntities[]
    private is_active: boolean
    private is_dev_only: boolean
    private is_sdk_flag: boolean

    public serialize(): any {
        return stripUndefined({
            key: this.getKey(),
            display_name: this.getDisplayName(),
            description: this.getDescription(),
            applicable_entities: this.getApplicableEntities(),
            default_for_entities: this.getDefaultForEntities(),
            is_active: this.getIsActive(),
            is_dev_only: this.getIsDevOnly(),
            is_sdk_flag: this.getIsSdkFlag(),
        })
    }

    public clone() {
        return FlagModel.build(this)
    }

    public setKey(key: string): void {
        this.key = key
    }
    public getKey(): string {
        return this.key
    }

    public setDisplayName(displayName: string): void {
        this.display_name = displayName
    }
    public getDisplayName(): string {
        return this.display_name
    }

    public setDescription(description: string | null): void {
        this.description = description
    }
    public getDescription(): string {
        return this.description === null ? null : this.description
    }

    public setApplicableEntities(applicableEntities: PlatformFlagEntities[]): void {
        this.applicable_entities = applicableEntities
    }
    public getApplicableEntities(): PlatformFlagEntities[] {
        return this.applicable_entities
    }

    public setDefaultForEntities(defaultForEntities: PlatformFlagEntities[]): void {
        this.default_for_entities = defaultForEntities
    }
    public getDefaultForEntities(): PlatformFlagEntities[] {
        return this.default_for_entities
    }

    public setIsActive(isActive: boolean): void {
        this.is_active = isActive
    }
    public getIsActive(): boolean {
        return this.is_active
    }

    public setIsDevOnly(isDevOnly: boolean): void {
        this.is_dev_only = isDevOnly
    }
    public getIsDevOnly(): boolean {
        return this.is_dev_only
    }

    public setIsSdkFlag(isSdkFlag: boolean): void {
        this.is_sdk_flag = isSdkFlag
    }
    public getIsSdkFlag(): boolean {
        return this.is_sdk_flag
    }
}
